import DataTable from "react-data-table-component";
import { Col } from "reactstrap";
import MonthFilterComponent from "../../Absen/components/filter/MonthFilterComponent";
import { SearchBar } from "../../../CommonElements";
import { useThemeContext } from "../../../Context/ThemeContext";
import { useEffect, useState } from "react";
import ShiftBulananColumns from "../constants/ShiftBulananColumns";

const ShiftListBulanan = ({
  data,
  monthFilter,
  updateMonthFilter,
  pending,
}) => {
  const { themeContext } = useThemeContext();
  const [stafList, setStafList] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    let newData = filterStaffWithShifts(data) || [];

    newData = newData.filter((item) =>
      item.nama?.toLowerCase().includes(filterText.toLowerCase()) || 
      item.shifts?.lokasi?.toLowerCase().includes(filterText.toLowerCase())
    );
    
    newData = newData.map((item) => ({ 
      ...item, 
      month: monthFilter,
      periode: item.shifts?.periode,
      lokasi: item.shifts?.lokasi
    }));

    setStafList(newData);
  }, [data, filterText]);

  useEffect(() => {
    let monthList = [];
    const startDate = new Date(monthFilter + "-01");
    const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    const totalDays = endDate.getDate();
    for (let i = 1; i <= totalDays; i++) {
      monthList.push({
        tanggal: new Date(startDate.getFullYear(), startDate.getMonth(), i),
      });
    }
    setDateList(monthList);
  }, [monthFilter]);

  const subHeaderComponent = (
    <div className="d-flex w-100 justify-content-between flex-row gap-1">
      <MonthFilterComponent
        updateMonthFilter={updateMonthFilter}
        absen={false}
      />
      <SearchBar 
        onChange={(e) => setFilterText(e.target.value)} 
        placeholder="Cari nama atau lokasi..."
      />
    </div>
  );

  function filterStaffWithShifts(staffData) {
    const hasAssignments = staffData.some(staff => 
      staff.shifts?.daily_shifts?.some(shift => shift.shift !== "")
    );
    
    if (!hasAssignments) {
      return staffData;
    }
    
    return staffData.filter(staff => 
      staff.shifts?.daily_shifts?.some(shift => shift.shift !== "")
    );
  }

  return (
    <DataTable
      data={stafList}
      columns={ShiftBulananColumns(dateList)}
      pagination
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign="right"
      progressPending={pending}
      theme={themeContext}
    />
  );
};

export default ShiftListBulanan;